// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".three-cols-box .col .field[data-v-dfda8830]:nth-child(2){margin-bottom:25px}", ""]);
// Exports
module.exports = exports;
